import type { MannequinSurfaceLayerVisibility } from "../../api/mannequin";

export type TailorPlotLayerId = keyof MannequinSurfaceLayerVisibility;

export const DEFAULT_TAILOR_PLOT_LAYERS: MannequinSurfaceLayerVisibility = {
  estimate: true,
  uncertainty: true,
  prior: true,
  truth: true,
  oracleTargets: true,
  samples: true,
};

export type TailorPlotLayerOption = {
  id: TailorPlotLayerId;
  label: string;
  detail?: string;
  swatch: "estimate" | "uncertainty" | "prior" | "oracle" | "oracle-target" | "samples";
};

export function resolvedTailorPlotLayers(
  layers?: Partial<MannequinSurfaceLayerVisibility>,
): MannequinSurfaceLayerVisibility {
  return { ...DEFAULT_TAILOR_PLOT_LAYERS, ...layers };
}

export function TailorPlotLayerControls({
  layers,
  options,
  onChange,
  className = "",
  testId,
}: {
  layers: MannequinSurfaceLayerVisibility;
  options: TailorPlotLayerOption[];
  onChange: (layers: MannequinSurfaceLayerVisibility) => void;
  className?: string;
  testId?: string;
}) {
  return (
    <div
      className={`tailor-plot-layer-controls ${className}`.trim()}
      aria-label="Plot layers"
      data-testid={testId}
    >
      {options.map((option) => {
        const visible = layers[option.id];
        return (
          <button
            key={option.id}
            type="button"
            className={`tailor-plot-layer-toggle is-${option.id}${visible ? " is-active" : ""}`}
            aria-label={`${visible ? "Hide" : "Show"} ${option.label}`}
            aria-pressed={visible}
            data-layer={option.id}
            onClick={() => onChange({ ...layers, [option.id]: !visible })}
          >
            <i className={`is-${option.swatch}`} aria-hidden="true" />
            <span>{option.label}</span>
            {option.detail ? <em>{option.detail}</em> : null}
          </button>
        );
      })}
    </div>
  );
}
